// ── 3D scene placement bounds ─────────────────────────────────────
//
// Single source of truth for how far an object (3D text, 3D sprite,
// device, …) can be placed from the world origin in the editor.
//
// `PositionPad3D` (X/Y pad + Z slider) maps pad coordinates ↔ world
// XY by projecting through a live PerspectiveCamera that mirrors the
// viewport's (cameraPosition + lookAt origin + `CAMERA_FOV_DEG` +
// live canvas aspect from `viewportSizeStore`). The pad corners
// therefore align with the visible canvas corners at any camera zoom
// AND orbit angle — `OBJECT_PLACEMENT_HALF_RANGE` is no longer used
// by the pad; typed input is clamped to a hard ±2000 safety bound.
// The device-depth slider still clamps to `OBJECT_PLACEMENT_HALF_RANGE`.
// `Sprite3DMeshV2`'s plane scale tops out at `OBJECT_HALF_EXTENT * 2`
// (longest side).
//
// `SCENE_MAX_REACH` is the worst-case absolute distance from origin
// at which a renderable surface can sit — used by `ShadowCatcher` to
// size the catcher plane, and by the directional-light shadow camera
// frustum so shadows from far-placed objects never get clipped.
//
// `CAMERA_FOV_DEG` mirrors the perspective FOV configured in
// `ViewportV2.tsx`; shared here so the position pad can size its
// range against the same frustum the viewport renders.

export const OBJECT_PLACEMENT_HALF_RANGE = 200
export const OBJECT_HALF_EXTENT = 100
export const SCENE_MAX_REACH = OBJECT_PLACEMENT_HALF_RANGE + OBJECT_HALF_EXTENT
export const CAMERA_FOV_DEG = 45

// Upper bound for the dynamically-fitted shadow coverage. The shadow-catcher
// plane is sized to this so it always receives the fitted shadow frustum, and
// the per-frame frustum fitter clamps its computed reach here. Covers the
// widest realistic visible region: at `ORBIT_MAX_DISTANCE` (1500) zoom-out
// with `CAMERA_FOV_DEG` and a wide feature-graphic aspect (~2:1) the visible
// half-extent is ≈1300, so 1800 leaves headroom for pan/tilt + large custom
// devices (which can reach ~1100 from origin).
export const MAX_SHADOW_REACH = 1800
